import {
  LEAVE_STATUS_LABELS,
  LEAVE_TYPE_LABELS,
} from "./staffHolidayConstants";

export const formatLeaveType = (leaveType) => {
  return LEAVE_TYPE_LABELS[leaveType] || leaveType || "";
};

export const formatLeaveStatus = (status) => {
  return LEAVE_STATUS_LABELS[status] || status || "";
};

export const getLeaveCodeForTracker = (leaveType, dayValue = 1) => {
  const prefixMap = {
    annual_leave: "AL",
    sick_leave: "S",
    unpaid_leave: "UL",
    paid_leave: "PL",
    compassionate_leave: "CL",
    parental_leave: "PR",
    lieu: "L",
    awol: "AW",
    other: "O",
  };

  const prefix = prefixMap[leaveType] || "";

  if (Number(dayValue) === 0.5) {
    return `${prefix} 0.5`;
  }

  return prefix;
};
